(function() {
    angular
        .module("app")
        .controller("DeleteTrackerModalController", DeleteTrackerModalController)

    DeleteTrackerModalController.$inject = [
        "$state",
        "$scope",
        "$uibModalInstance",
        "trackersService",
        "userMessagingService",
        "tracker"
    ]

    function DeleteTrackerModalController(
        $state,
        $scope,
        $uibModalInstance,
        trackersService,
        userMessagingService,
        tracker
    ){
        "use strict"

        $scope.tracker = tracker

        $scope.ok = function() {
            var success = function() {
                gtag("event", "delete_device", { device_id: tracker.device.id })
                $state.go($state.$current, null, { reload: true }).then(() => {
                    userMessagingService.success("Tracker Successfully Deleted")
                })
            }

            var failure = function(error) {
                userMessagingService.error("Tracker Delete Failed: " + error)
            }

            $uibModalInstance.close(trackersService.deleteTracker(tracker.id, success, failure))
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
